import { useState } from "react";
import { setUserPermissions } from "@/lib/apiClient";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";

const PERMS = [["services_kb", "Diensten & kennisbank bewerken"], ["scripts", "Belscripts & antwoorden bewerken"]];
const today = () => new Date().toISOString().slice(0, 10);
const active = (p) => !p.until || p.until >= today();

// Temporary, task-based edit rights for a non-admin user (no full admin access).
export function UserPermissions({ u, onSaved }) {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState({});
  const current = (u.permissions || []).filter(active);
  const start = () => { setDraft(Object.fromEntries(current.map((p) => [p.key, p.until || ""]))); setOpen(true); };
  const save = async (perms) => {
    try { const r = await setUserPermissions(u.id, perms); onSaved(r.permissions); toast.success(perms.length ? "Rechten opgeslagen" : "Rechten ingetrokken"); setOpen(false); }
    catch (e) { toast.error(e?.response?.data?.detail || "Opslaan mislukt"); }
  };
  return (
    <div className="basis-full" data-testid={`perms-${u.id}`}>
      <div className="flex flex-wrap items-center gap-2">
        <button data-testid={`perms-btn-${u.id}`} onClick={() => (open ? setOpen(false) : start())} className="inline-flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-lg border border-[#E2E7EC] text-[#001C51] hover:bg-[#EDF1F5]">
          <KeyRound className="h-3.5 w-3.5" /> Extra rechten
        </button>
        {current.map((p) => (
          <span key={p.key} data-testid={`perm-chip-${u.id}-${p.key}`} className="text-xs px-2.5 py-1 rounded-full bg-[#FFF4DB] text-[#7A5410]">
            {PERMS.find((x) => x[0] === p.key)?.[1]}{p.until ? ` · t/m ${new Date(p.until).toLocaleDateString("nl-NL")}` : " · onbeperkt"}
          </span>
        ))}
        {current.length > 0 && <button data-testid={`perms-revoke-${u.id}`} onClick={() => save([])} className="text-xs text-[#B0413E] hover:underline">Alles intrekken</button>}
      </div>
      {open && (
        <div className="mt-2 rounded-xl border border-[#E2E7EC] bg-[#F6F9FB] p-3 space-y-2">
          {PERMS.map(([key, label]) => (
            <div key={key} className="flex flex-wrap items-center gap-3">
              <label className="inline-flex items-center gap-2 text-sm text-[#16202B] w-72">
                <input type="checkbox" data-testid={`perm-${u.id}-${key}`} checked={key in draft} className="accent-[#16BFBF] h-4 w-4"
                  onChange={(e) => setDraft((d) => { const n = { ...d }; if (e.target.checked) n[key] = ""; else delete n[key]; return n; })} /> {label}
              </label>
              {key in draft && <label className="text-xs text-[#5B6675] inline-flex items-center gap-2">tot en met
                <input type="date" data-testid={`perm-until-${u.id}-${key}`} min={today()} value={draft[key]} onChange={(e) => setDraft((d) => ({ ...d, [key]: e.target.value }))} className="fe-input py-1 w-40" />
                <span className="text-[11px]">(leeg = tot je het intrekt)</span></label>}
            </div>
          ))}
          <button data-testid={`perms-save-${u.id}`} onClick={() => save(Object.entries(draft).map(([key, until]) => ({ key, until })))} className="px-3 py-1.5 rounded-lg bg-[#001C51] text-white text-xs font-medium hover:bg-[#0A337A]">Rechten opslaan</button>
        </div>
      )}
    </div>
  );
}
